{
  "captureBulkDeleteDialog": {
    "text": "Deleting...",
    "title": "Delete {{length}} items?",
    "text2": "This action can't be undone. Continue?",
    "text3": "Selected:",
    "text4": " items",
    "text5": "To be deleted:",
    "text6": "(Untitled)",
    "error": "Unsupported type: {{recordType}}"
  },
  "captureDeleteDialog": {
    "text": "The deletion failed.",
    "text2": "Deleting...",
    "title": "Delete this item?",
    "text3": "This action can't be undone. Continue?",
    "text4": "Title:",
    "text5": "Recorded period:"
  },
  "captureEditDialog": {
    "required": "Enter a title.",
    "max": "The title must be 255 characters or fewer.",
    "max2": "The memo must be 1,000 characters or fewer.",
    "clip": "Clip",
    "snapshot": "Snapshot",
    "timelapse": "Timelapse",
    "handsRecord": "Hands recording",
    "error": "CaptureEditDialog: Editing hands_record isn't supported.",
    "text": "Updating...",
    "alert": "Loading failed.",
    "label": "Title",
    "label2": "Memo",
    "label3": "Area name",
    "label4": "Camera name",
    "label5": "Created at",
    "label6": "Created by",
    "label7": "Type",
    "label8": "Size"
  },
  "captureFilterBar": {
    "label": "All",
    "label2": "Clip",
    "label3": "Timelapse",
    "label4": "Snapshot",
    "label5": "Hands recording",
    "label6": "Processing",
    "label7": "Playable",
    "label8": "Failed",
    "placeholder": "Search by title, camera, or area",
    "button": "Filter",
    "label9": "Created date",
    "label10": "Camera",
    "label11": "Type",
    "label12": "Status"
  },
  "captureTable": {
    "processing": "Processing",
    "completed": "Playable",
    "failed": "Failed",
    "removed": "Deleted",
    "clip": "Clip",
    "snapshot": "Snapshot",
    "timelapse": "Timelapse",
    "text": " selected",
    "label": "Title",
    "label2": "Camera name",
    "label3": "Recorded period",
    "label4": "Created at",
    "label5": "Status",
    "label6": "Size",
    "label7": "Recreate",
    "label8": "Download",
    "text2": "No captures available"
  },
  "captureView": {
    "showSnackbar": "Error",
    "showSnackbar2": "The download URL couldn't be retrieved.",
    "showSnackbar3": "The download failed.",
    "showSnackbar4": "The Hands recording ID couldn't be retrieved.",
    "showSnackbar5": "Deleted {{length}} items",
    "showSnackbar6": "The bulk deletion failed.",
    "showSnackbar7": "Deleted {{length}} items ({{length2}} failed)",
    "title": "Captures",
    "showSnackbar8": "The update failed.",
    "showSnackbar9": "Updated",
    "text": "The deletion failed.",
    "showSnackbar10": "Deleted"
  },
  "clipDeleteDialog": {
    "text": "The clip couldn't be deleted.",
    "text2": "Deleting...",
    "title": "Delete this clip?",
    "text3": "This action can't be undone. Continue?",
    "text4": "Title:",
    "text5": "Recorded period:"
  },
  "clipEditDialog": {
    "required": "Enter a title.",
    "max": "The title must be 255 characters or fewer.",
    "text": "Clip",
    "text2": "Timelapse",
    "enqueueSnackbar": "Clip updated",
    "enqueueSnackbar2": "The clip couldn't be updated.",
    "text3": "Updating...",
    "title": "Edit clip",
    "label": "Title",
    "label2": "Reference number",
    "label3": "Recorded period",
    "label4": "Size",
    "label5": "Area name",
    "label6": "Camera name",
    "label7": "Created at",
    "label8": "Created by",
    "label9": "Type",
    "label10": "Speed",
    "value": "{{timelapseSpeedRate}}x"
  },
  "clipFilterBar": {
    "label": "All",
    "label2": "Requested",
    "label3": "Creating",
    "label4": "Uploading",
    "label5": "Playable",
    "label6": "Creation failed",
    "placeholder": "Search by title, camera, or area",
    "button": "Filter",
    "label7": "Created date",
    "label8": "Camera",
    "label9": "Status"
  },
  "clipPagination": {
    "text": " items"
  },
  "clipRestartDialog": {
    "enqueueSnackbar": "Recreating timelapses isn't currently supported.",
    "enqueueSnackbar2": "The clip was recreated.",
    "enqueueSnackbar3": "An error occurred while recreating the clip.",
    "text": "Recreating...",
    "text2": "Recreate",
    "title": "Recreate this clip?",
    "text3": "The following clip will be recreated.",
    "text4": "Title:",
    "text5": "Recorded period:"
  },
  "clipTable": {
    "requested": "Requested",
    "creating": "Creating",
    "created": "Created",
    "uploading": "Uploading",
    "uploaded": "Playable",
    "failed": "Failed",
    "text": "Clip",
    "text2": "Timelapse",
    "text3": " selected",
    "label": "Camera name",
    "label2": "Clip period",
    "label3": "Created at",
    "label4": "Status",
    "label5": "File size",
    "label6": "Recreate",
    "label7": "Download",
    "text4": "No clips available"
  },
  "clipVideoPlayerDialog": {
    "ariaLabel": "Seek",
    "ariaLabel2": "Volume",
    "text": "Normal",
    "text2": "{{speed}}x",
    "title": "Download",
    "title2": "Picture-in-picture"
  },
  "snapshotPreviewDialog": {
    "text": "Downloading...",
    "text2": "Download",
    "text3": "Snapshot",
    "text4": "Upload in progress. The snapshot will appear in this dialog when it's done.",
    "text5": "The upload couldn't be confirmed as complete.",
    "text6": "Wait a while and try again.",
    "button": "Reload",
    "text7": "The download failed.",
    "text8": "Memo:",
    "text9": "Camera:",
    "text10": "Captured at:"
  },
  "useCameraOptions": {
    "text": "Unknown area"
  },
  "useCapturesTabs": {
    "label": "All",
    "label2": "Archive"
  },
  "useCapturesUsageText": {
    "text": "{{totalCount}} items",
    "text2": "{{totalCount}} items (total usage {{value}} / {{value2}})",
    "text3": "{{totalCount}} items (total usage {{value}})"
  },
  "useClipTabs": {
    "label": "All",
    "label2": "Archive"
  },
  "useClipUsageText": {
    "text": "{{filteredCount}} items (total usage {{value}} / {{value2}})",
    "text2": "{{filteredCount}} items (total usage {{value}})"
  }
}
